import React, { useState, useEffect } from 'react';
import styles from './RegionsTab.module.scss';
import { Pencil, Trash2, X } from 'lucide-react';
import { DEBUG, PATH } from '../../../utils/constants';

import Modal from '../Modal/Modal';


const debug = DEBUG;


function RegionsTab({ 
    regions, 
    villages, 
    onCreateRegion, 
    onUpdateRegion, 
    onDeleteRegion, 
    onCreateVillage, 
    onUpdateVillage,
    onDeleteVillage,
    onVillageSelect 

}) {
    const [villageName, setVillageName] = useState('');
    const [regionInput, setRegionInput] = useState('');
    const [filteredRegions, setFilteredRegions] = useState(regions);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [selected, setSelected] = useState(null);
    const [localVillages, setLocalVillages] = useState(villages);

    // États pour les modales
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isEditVillageModalOpen, setIsEditVillageModalOpen] = useState(false);
    const [isDeleteVillageModalOpen, setIsDeleteVillageModalOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [editName, setEditName] = useState('');

    const [hasVillages, setHasVillages] = useState(false); // Pour savoir si une région contient des villages lors de la tentative de suppression


    useEffect(() => {
        if (selected) {
            setLocalVillages(villages.filter(village => village.id_region === selected.id).sort((a, b) => a.nom.localeCompare(b.nom))); // Tri alphabétique);
        } else {
            setLocalVillages(villages); // Réinitialise si aucune région sélectionnée
        }
    }, [selected, villages]); 

    useEffect(() => {
        console.log("localVillages mis à jour :", localVillages);
    }, [localVillages]);

    useEffect(() => { //Nouvel ajout à tester !!!
        setFilteredRegions(regions);
    }, [regions]);

    const handleRegionInputChange = (e) => {
        const value = e.target.value;
        setRegionInput(value);

        if (value.trim() === '') {
            setFilteredRegions(regions);
            setDropdownVisible(false);
        } else {
            const matches = regions.filter((region) =>
                region.nom.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredRegions(matches);
            setDropdownVisible(true);
        }
    };

    const handleSelectRegion = (region) => {
        setRegionInput(region.nom);
        setSelected(region);
        setDropdownVisible(false);
    };

    const handleClearSelectedRegion = () => {
        setSelected(null);
        setRegionInput('');
    };

    const handleCreateRegion = async () => {
        if (!regionInput.trim()) return;
        const created = await onCreateRegion(regionInput);
        if (created) {
            setSelected(created);
            setRegionInput(created.nom);
        }
        setDropdownVisible(false);
    };

    const handleCreateVillage = async (e) => {
        e.preventDefault();
        if (!villageName.trim() || !selected) return;

        await onCreateVillage(selected.id, villageName);
        setVillageName('');
    };

    const handleVillageClick = (village) => {
        onVillageSelect(village);
    };

    // Fonctions pour gérer les modales
    const openEditModal = (region, e) => {
        e.stopPropagation();
        setCurrentItem(region);
        setEditName(region.nom);
        setIsEditModalOpen(true);
    };

    const openDeleteModal = (region, e) => {
        e.stopPropagation();
        setCurrentItem(region);

        const villagesInRegion = villages.filter(v => v.id_region === region.id);
        if (villagesInRegion.length > 0) {
            setHasVillages(true);
        } else {
            setHasVillages(false);
        }

        setIsDeleteModalOpen(true);
    };

    const openEditVillageModal = (village, e) => {
        e.stopPropagation();
        setCurrentItem(village);
        setEditName(village.nom);
        setIsEditVillageModalOpen(true);
    };

    const openDeleteVillageModal = (village, e) => {
        e.stopPropagation();
        setCurrentItem(village);
        setIsDeleteVillageModalOpen(true);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!editName.trim() || !currentItem) return;
        
        const success = await onUpdateRegion(currentItem.id, editName);
        if (success) {
            if (selected && selected.id === currentItem.id) {
                setSelected(prev => ({ ...prev, nom: editName }));
                setRegionInput(editName);
            }
            setIsEditModalOpen(false);
        }
    };

    const handleDeleteConfirm = async () => {
        if (!currentItem) return;
        
        const success = await onDeleteRegion(currentItem.id);
        if (success) {
            if (selected && selected.id === currentItem.id) {
                setSelected(null);
                setRegionInput('');
            }
            setIsDeleteModalOpen(false);
        }
    };

    const handleEditVillageSubmit = async (e) => {
        e.preventDefault();
        if (!editName.trim() || !currentItem) return;
        
        const success = await onUpdateVillage(currentItem.id, editName);
        if (success) {
            setIsEditVillageModalOpen(false);
        }
    };

    const handleDeleteVillageConfirm = async () => {
        if (!currentItem) return;
        
        const success = await onDeleteVillage(currentItem.id);
        if (success) {
            setIsDeleteVillageModalOpen(false);
        }
    };

    return (
        <div className={styles.tabContainer}>
            <div className={styles.mainSection}>
                <h2 className={styles.title}>Gérer les régions et villages associés</h2>

                {/* <label htmlFor="regionInput" className={styles.label}>Région :</label> */}
                <div className={styles.regionInputContainer}>
                    <input
                        id="regionInput"
                        type="text"
                        value={regionInput}
                        onChange={handleRegionInputChange}
                        placeholder="Rechercher ou créer une région"
                        className={!selected? styles.regionInput : styles.regionInputShort}
                    />
                    {selected && (
                        <button
                            type="button"
                            className={styles.clearButton}
                            onClick={handleClearSelectedRegion}
                        >
                            <X size={35} />
                        </button>
                    )}
                    {dropdownVisible && filteredRegions.length > 0 && (
                        <ul className={styles.dropdown}>
                            {filteredRegions.map((region) => (
                                <li
                                    key={region.id}
                                    onClick={() => handleSelectRegion(region)}
                                    className={styles.dropdownItem}
                                >
                                    {region.nom}
                                </li>
                            ))}
                        </ul>
                    )}
                    {dropdownVisible && !filteredRegions.length && regionInput.trim() && (
                        <button
                            type="button"
                            className={styles.createRegionButton}
                            onClick={handleCreateRegion}
                        >
                            Créer Région "{regionInput}"
                        </button>
                    )}
                </div>

                {selected && (
                    <form onSubmit={handleCreateVillage} className={styles.form}>
                        <label htmlFor="villageName" className={styles.label}>Ajouter un nouveau village pour la région {selected.nom}</label>
                        <input
                            id="villageName"
                            type="text"
                            value={villageName}
                            onChange={(e) => setVillageName(e.target.value)}
                            placeholder="Entrez le nom du village à insérer"
                            required
                            className={styles.input}
                        />
                        <button type="submit" className={styles.submitButton}>Créer Village</button>
                    </form>
                )}

                <h3 className={styles.listTitle}>
                    {selected ? `Sélectionnez un village pour commencer` : "Sélectionnez une région"}
                </h3>
                {!selected && (
                    <p className={styles.explaination}>Pour commencer, recherchez une région existante en saisissant son nom dans le champ prévu à cet effet. Si elle n'existe pas, vous pouvez la créer en cliquant sur le bouton 'Créer Région'. <br />
                        Une fois la région sélectionnée, vous pourrez accéder à sa liste de villages ou lui en ajouter un nouveau et poursuivre vos actions.</p>
                )}
            </div>

            <hr className={styles.hr} />
            
            <div className={styles.aside}>
                {selected ? (
                        <ul className={styles.list}>
                            {localVillages.map((village) => (
                                <div key={village.id} className={styles.listItemRow}>
                                    <li key={village.id} className={styles.listItem} onClick={() => handleVillageClick(village)}>
                                        <strong className={styles.listItemStrong}>{village.nom}</strong>
                                        <button className={styles.listItemLink}>Sélectionner</button>
                                    </li>
                                    <div className={styles.modButtons}>
                                        <button 
                                            className={styles.editButton} 
                                            onClick={(e) => openEditVillageModal(village, e)}
                                        >
                                            <Pencil />
                                        </button>
                                        <hr className={styles.hr} />
                                        <button 
                                            className={styles.deleteButton} 
                                            onClick={(e) => openDeleteVillageModal(village, e)}
                                        >
                                            <Trash2 />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </ul>
                    ) : (
                        <ul className={styles.list}>
                            {regions.map((region) => (
                                <div key={region.id} className={styles.listItemRow}>
                                    <li className={styles.listItem} onClick={() => handleSelectRegion(region)}>
                                        <div>
                                            <strong className={styles.listItemStrong}>{region.nom}</strong>
                                            <button className={styles.listItemLink} >Sélectionner</button>
                                        </div>
                                    </li>
                                    <div className={styles.modButtons}>
                                        <button className={styles.editButton} onClick={(e) => openEditModal(region, e)}>
                                            <Pencil />
                                        </button>
                                        <hr className={styles.hr} />
                                        <button className={styles.deleteButton} onClick={(e) => openDeleteModal(region, e)}>
                                            <Trash2 />
                                        </button>
                                    </div>
                                </div>
                                
                            ))}
                        </ul>
                    )}
            </div>

            {/* Modales */}
            {/* Modale pour modifier une région */}
            <Modal 
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                title="Modifier la région"
                className={styles.modal}
            >
                <form onSubmit={handleEditSubmit}>
                    <div className={styles.formControl}>
                        <label htmlFor="editRegionName" className={styles.label}>Nom de la région:</label> <br />
                        <input
                            id="editRegionName"
                            type="text"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                            className={styles.input}
                            required
                        />
                    </div>
                    <div className={styles.buttonContainer}>
                        <button 
                            type="button" 
                            className={styles.cancelButton}
                            onClick={() => setIsEditModalOpen(false)}
                        >
                            Annuler
                        </button>
                        <button 
                            type="submit" 
                            className={styles.submitButton}
                        >
                            Enregistrer
                        </button>
                    </div>
                </form>
            </Modal>

            {/* Modal pour supprimer une région */}
            <Modal 
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                title="Supprimer la région"
            >
                {hasVillages ? (
                    <>
                        <p className={styles.confirmText}>
                            La région "{currentItem?.nom}" contient des villages. Vous devez d'abord supprimer ces villages avant de pouvoir supprimer la région.
                        </p>
                        <div className={styles.buttonContainer}>
                            <button 
                                type="button" 
                                className={styles.cancelButton}
                                onClick={() => setIsDeleteModalOpen(false)}
                            >
                                Retour
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <p className={styles.confirmText}>
                            Êtes-vous sûr de vouloir supprimer la région "{currentItem?.nom}" ?
                        </p>
                        <div className={styles.buttonContainer}>
                            <button 
                                type="button" 
                                className={styles.neutralButton}
                                onClick={() => setIsDeleteModalOpen(false)}
                            >
                                Annuler
                            </button>
                            <button 
                                type="button" 
                                className={styles.dangerButton}
                                onClick={handleDeleteConfirm}
                            >
                                Supprimer
                            </button>
                        </div>
                    </>
                )}
            </Modal>

            {/* Modal pour modifier un village */}
            <Modal 
                isOpen={isEditVillageModalOpen}
                onClose={() => setIsEditVillageModalOpen(false)}
                title="Modifier le village"
            >
                <form onSubmit={handleEditVillageSubmit}>
                    <div className={styles.formControl}>
                        <label htmlFor="editVillageName" className={styles.label}>Nom du village:</label>
                        <input
                            id="editVillageName"
                            type="text"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                            className={styles.input}
                            required
                        />
                    </div>
                    <div className={styles.buttonContainer}>
                        <button 
                            type="button" 
                            className={styles.cancelButton}
                            onClick={() => setIsEditVillageModalOpen(false)}
                        >
                            Annuler
                        </button>
                        <button 
                            type="submit" 
                            className={styles.submitButton}
                        >
                            Enregistrer
                        </button>
                    </div>
                </form>
            </Modal>

            {/* Modal pour supprimer un village */}
            <Modal 
                isOpen={isDeleteVillageModalOpen}
                onClose={() => setIsDeleteVillageModalOpen(false)}
                title="Supprimer le village"
            >
                <p className={styles.confirmText}>
                    Êtes-vous sûr de vouloir supprimer le village <strong>{currentItem?.nom}</strong> ? 
                    Cette action supprimera également tous les parcours associés.
                </p>
                <div className={styles.buttonContainer}>
                    <button 
                        type="button" 
                        className={styles.neutralButton}
                        onClick={() => setIsDeleteVillageModalOpen(false)}
                    >
                        Annuler
                    </button>
                    <button 
                        type="button" 
                        className={styles.dangerButton}
                        onClick={handleDeleteVillageConfirm}
                    >
                        Supprimer
                    </button>
                </div>
            </Modal>
        </div>
    );
}

export default RegionsTab;
